








































import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'

export default BaseCmsBlock.extend({
    name: "NavigationMenuBlock",
    data() {
        return {}
    },

  computed: {
      extraItems: function () {
        let items = [...this.values.items];
        if (this.$store.state.device.device.isMobile) {
          items = items.sort((a, b) => {
            if (a.sort > b.sort) {
              return 1
            }
            if (a.sort < b.sort) {
              return -1
            }
            return 0
          })
        }
        return items
      },
    cityName: function () {
        return this.appCfg?.city?.model?.name || 'Екатеринбург'
    }
  }
});

